import strings from "@/lang/strings";
import React, { lazy } from "react";

import AddFranchise from "@/pages/1.payment/franchise/Add_franchise";
import DetailFrnachise from "@/pages/1.payment/franchise/Detail_frnachise";
import EditFranchise from "@/pages/1.payment/franchise/Edit_franchise";

// lazy imports
const Find = lazy(() => import("@/pages/auth/find"));
//const Login = lazy(() => import("@/pages/auth/login"));
//const LoginEmail = lazy(() => import("@/pages/auth/login_email"));
const Signup = lazy(() => import("@/pages/auth/signup"));
const LoginId = lazy(() => import("@/pages/auth/login_id"));

// 플랫폼 관리
const Platform = lazy(() => import("@/pages/1.payment/platform/Platform"));
const AddPlatform = lazy(
  () => import("@/pages/1.payment/platform/Add_platform")
);
const EditPlatform = lazy(
  () => import("@/pages/1.payment/platform/Edit_platform")
);
const Franchise = lazy(() => import("@/pages/1.payment/franchise/Franchise"));

// 결제 관리
const PaymentHistory = lazy(
  () => import("@/pages/1.payment/payment-history/Payment_history")
);
const DetailPaymentHistory = lazy(
  () => import("@/pages/1.payment/payment-history/Detail_payment_history")
);

export interface IMenu {
  path: string;
  title: string;
  iconActive?: React.ReactNode;
  iconInactive?: React.ReactNode;
  user_type?: string;
  private?: boolean;
  children: {
    path: string;
    title: string;
    exact?: boolean;
    private?: boolean;
    component: () => React.ReactNode;
    user_type?: string;
    containPath?: string[];
  }[];
}

export interface ISubMenu {
  path: string;
  title: string;
  exact?: boolean;
  private?: boolean;
  component: () => React.ReactNode;
  user_type?: string;
  containPath?: string[];
}

export const ClassExtra: ISubMenu[] = [
  {
    path: "/login",
    title: strings.login.login,
    exact: true,
    private: false,
    component: () => <LoginId />,
  },
  // {
  //   path: "/login",
  //   title: strings.login.login,
  //   exact: true,
  //   private: false,
  //   component: () => <LoginEmail />,
  // },
  {
    path: "/signup/:step",
    title: strings.signup,
    exact: true,
    private: false,
    component: () => <Signup />,
  },
  {
    path: "/find/:step",
    title: strings.find,
    exact: true,
    private: false,
    component: () => <Find />,
  },

  // 결제 관리 ////////////////////////////////
  // 플랫폼 관리
  {
    path: "/payment/platform-add",
    title: "플랫폼 등록",
    exact: true,
    private: false,
    component: () => <AddPlatform />,
    containPath: ["/payment/platform-add"],
  },
  {
    path: "/payment/platform-edit/:id",
    title: "플랫폼 수정",
    exact: true,
    private: false,
    component: () => <EditPlatform />,
    containPath: ["/payment/platform-edit/:id"],
  },
  // 가맹점 관리
  {
    path: "/payment/franchise-detail/:id",
    title: "가맹점 정보",
    exact: true,
    private: false,
    containPath: ["/payment/franchise-detail/:id"],
    component: () => <DetailFrnachise />,
  },
  {
    path: "/payment/franchise-add",
    title: "가맹점 등록",
    exact: true,
    private: false,
    component: () => <AddFranchise />,
    containPath: ["/payment/franchise-add"],
  },
  {
    path: "/payment/franchise-edit/:id",
    title: "가맹점 수정",
    exact: true,
    private: false,
    component: () => <EditFranchise />,
    containPath: ["/payment/franchise-edit/:id"],
  },

  // 결제 내역
  {
    path: "/payment/payment-history-detail/:id",
    title: "결제 내역 상세",
    exact: true,
    private: false,
    component: () => <DetailPaymentHistory />,
    containPath: ["/payment/payment-history-detail/:id"],
  },
];

export const ClassMenu: IMenu[] = [
  // 결제 관리
  {
    path: "/payment",
    title: strings.menu.payments,
    children: [
      {
        path: "/payment/platform-list",
        title: "플랫폼 관리",
        exact: true,
        private: false,
        component: () => <Platform />,
        containPath: [
          "/payment/platform-list",
          "/payment/platform-detail/:id",
          "/payment/platform-add",
          "/payment/platform-edit/:id",
        ],
      },
      {
        path: "/payment/franchise-list",
        title: "가맹점 관리",
        exact: true,
        private: false,
        component: () => <Franchise />,
        containPath: [
          "/payment/franchise-list",
          "/payment/franchise-detail/:id",
          "/payment/franchise-add",
          "/payment/franchise-edit/:id",
        ],
      },
      {
        path: "/payment/payment-history-list",
        title: "결제 내역",
        exact: true,
        private: false,
        component: () => <PaymentHistory />,
        containPath: [
          "/payment/payment-history-list",
          "/payment/payment-history-detail/:id",
        ],
      },
    ],
  },
];
